<template>
<div class="wrapper">
  <div>
    <CRow class="mt-3">
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable
                            :items="items"
                            :fields="fields"
                            :meta="meta"
                            :status="status"
                            :sorter-value="{ column: sortBy, asc: !sortByDesc }"
                            @per_page="handlePerPage"
                            @pagination="handlePagination"
                            @search="handleSearch"
                            @sort="handleSort"
                            @status="handleStatus"
                            @show="handleShow"
                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
  </div>
</div>
</template>

<script>
import Datatable from '@/components/datatables_icare_join.vue'

import icare from '@/services/icare';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

export default {
  name: 'IcareTables',
  components: { Datatable, alertmodal },
   data () {
    return {
      fields: [
          {key: 'name', label: 'Name', sorter: false},
          {key: 'email', label: 'Email', sorter: false},
          {key: 'phone', label: 'Phone Number', sorter: false},
          {key: 'icare_name', label: 'Requested iCare', sorter: false},
          {key: 'icl_name', label: 'iCL', sorter: false},
          {key: 'created_at', label: 'Request Date'},
          {key: 'status_label', label: 'Request Status', sorter: false},
          {key: 'action', label: 'Action', sorter: false},
      ],
      items: [],
      meta: {},
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'created_at',
      sortByDesc: true,
      status: 'all',
    }
   },
   mounted (){
     this.loadData()
   },

  methods: {
    loadData() {
      var params = {
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        status: this.status,
      }

      icare.getIcareDataSourceJoin(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data: err.response && err.response.data ? err.response.data.message : 'Failed to load data'}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val
        this.current_page = 1
        this.loadData()
    },

    handlePagination(val) {
        this.current_page = val
        this.loadData()
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.loadData()
    },

    handleSort(val) {
        this.sortBy = val.sortBy || 'created_at'
        this.sortByDesc = val.sortDesc
        this.current_page = 1
        this.loadData()
    },

    handleStatus(val) {
        this.status = val
        this.current_page = 1
        this.loadData()
    },

    handleShow(id) {
        this.$router.push({ path: `/icare/icare_join/${id}` })
    },
  }
}
</script>
